var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingAudioButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.997,
    height: 38.997,
    viewBox: "0 0 38.997 38.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)",
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("g", {
    id: "mic",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8873",
    "data-name": "\\u9577\\u65B9\\u5F62 8873",
    width: 38.997,
    height: 38.997,
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20329",
    "data-name": "\\u30D1\\u30B9 20329",
    d: "M14.55,23.289a6.55,6.55,0,0,0,6.55-6.55V8.55A6.55,6.55,0,0,0,8,8.55v8.188a6.55,6.55,0,0,0,6.55,6.55Z",
    transform: "translate(5.101 1.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20330",
    "data-name": "\\u30D1\\u30B9 20330",
    d: "M27.927,11.638a1.638,1.638,0,0,0-3.275,0,8.188,8.188,0,0,1-16.376,0,1.638,1.638,0,0,0-3.275,0A11.463,11.463,0,0,0,14.826,22.97v3.406H11.37a1.457,1.457,0,0,0-1.457,1.457v.36a1.457,1.457,0,0,0,1.457,1.457H21.556a1.457,1.457,0,0,0,1.457-1.457v-.36a1.457,1.457,0,0,0-1.457-1.457H18.1V22.97A11.463,11.463,0,0,0,27.927,11.638Z",
    transform: "translate(3.188 6.328)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingAudioButton);
export default __webpack_public_path__ + "static/media/settingAudioButton.8c18d203fcedd40915d58dbb23dc1090.svg";
export { ForwardRef as ReactComponent };